import { render, staticRenderFns } from "./feedback-add-and-update.vue?vue&type=template&id=4128834e"
import script from "./feedback-add-and-update.vue?vue&type=script&lang=js"
export * from "./feedback-add-and-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4128834e')) {
      api.createRecord('4128834e', component.options)
    } else {
      api.reload('4128834e', component.options)
    }
    module.hot.accept("./feedback-add-and-update.vue?vue&type=template&id=4128834e", function () {
      api.rerender('4128834e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/feedback/feedback-add-and-update.vue"
export default component.exports